module.exports = __webpack_public_path__ + "static/img/12.ddceba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/12.png
// module id = YSQ2
// module chunks = 4